module.exports = __webpack_public_path__ + "static/media/phone_11.344301d0.png";